import { useUser } from "../contexts/UserContext";
import { Sidebar } from "./Sidebar";
import { AdminDashboard } from "./dashboards/AdminDashboard";
import { ModuleManagement } from "../pages/ModuleManagement";
import { ModuleEditor } from "./modules/ModuleEditor";
import { UserManagement } from "../pages/UserManagement";
import { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { MappingComponent } from "./modules/MappingComponent";
import BeltManagement from "../pages/BeltManagement";
import ModuleExecutionReport from '../pages/ModuleExecutionReport';
import { SellerTrainingProgressReport } from '../pages/SellerTrainingProgressReport';

export const Dashboard = () => {
  const { currentUser } = useUser();
  const [activeSection, setActiveSection] = useState("dashboard");
  const location = useLocation();
  const { id } = useParams();

  // Update active section when location changes
  useEffect(() => {
    const path = location.pathname;
    if (path === "/dashboard") {
      setActiveSection("dashboard");
    } else if (path === "/modules") {
      setActiveSection("modules");
    } else if (path === "/users") {
      setActiveSection("users");
    } else if (path === "/settings") {
      setActiveSection("settings");
    } else if (path.startsWith("/reports/")) {
      setActiveSection("reports");
    }
  }, [location.pathname]);

  if (!currentUser) return null;

  const renderContent = () => {
    const path = location.pathname;
    
    if (path === "/dashboard") {
      return <AdminDashboard />;
    }
    
    if (path === "/modules") {
      return <ModuleManagement />;
    }
    
    if (path === "/modules/new") {
      return <ModuleEditor isAdmin={currentUser.role === "admin"} />;
    }

    if (path.startsWith("/modules/") && id && path.endsWith("/mapping")) {
      return <MappingComponent moduleId={id} />;
    }

    if (path.startsWith("/modules/") && id) {
      return <ModuleEditor moduleId={id} isAdmin={currentUser.role === "admin"} />;
    }

    if (path === "/users") {
      return <UserManagement />;
    }

    if (path === "/belt-management") {
      return <BeltManagement />;
    }

    if (path === "/reports/module-execution") {
      return <ModuleExecutionReport />;
    }

    if (path === "/reports/seller-training-progress") {
      return <SellerTrainingProgressReport />;
    }

    return <AdminDashboard />;
  };

  return (
    <div className="flex h-screen bg-background">
      <Sidebar activeSection={activeSection} setActiveSection={setActiveSection} />
      <main className="flex-1 overflow-y-auto">
        {renderContent()}
      </main>
    </div>
  );
}; 